@import '~style-sheet-helpers/core.less';

.delete-modal {
  height: 450px;
  width: 780px;
}

.modal-body {
  height: 100%;
}

.modal-body.iframe-mode {
  div,
  iframe {
    border: 0;
    height: 100%;
    width: 100%;
  }
}
